import React, { useEffect, useState } from "react";
import { FcImageFile } from "react-icons/fc";
import {
  FiHome,
  FiLogOut,
  FiSettings,
  FiBook,
  FiBookOpen,
  FiLayers,
  FiList,
  FiFileText,
  FiFile,
  FiFileMinus,
  FiUsers,
  FiPackage,
} from "react-icons/fi";
import { Link, useLocation } from "react-router-dom";

const Menus = () => {
  const location = useLocation();
  const path = location.pathname.split("/").filter(Boolean);

  // const currentParent = path[0];
  const currentChild = path[1];

  const [openDropdown, setOpenDropdown] = useState(null);

  useEffect(() => {
    if (
      location.pathname.startsWith("/master/") &&
      !location.pathname.includes("package") &&
      !location.pathname.includes("student")
    ) {
      setOpenDropdown("master");
    } else if (location.pathname.includes("package")) {
      setOpenDropdown("package");
    } else if (location.pathname.includes("student")) {
      setOpenDropdown("student");
    }
  }, [location.pathname]);

  return (
    <ul className="sidebar-menu">
      {/* DASHBOARD */}
      <li
        className={`nxl-item ${location.pathname === "/home" ? "active" : ""}`}
      >
        <Link to="/home" className="nxl-link text-capitalize">
          <span className="nxl-micon">
            <FiHome />
          </span>
          <span className="nxl-mtext ps-1">Dashboard</span>
        </Link>
      </li>

      {/* MANAGE MASTER DROPDOWN */}
      <li
        className={`nxl-item nxl-hasmenu ${
          openDropdown === "master" ? "active nxl-trigger" : ""
        }`}
        onClick={() =>
          setOpenDropdown((prev) => (prev === "master" ? null : "master"))
        }
      >
        <Link to="#" className="nxl-link text-capitalize">
          <span className="nxl-micon">
            <FiSettings />
          </span>
          <span className="nxl-mtext ps-1">Manage Master</span>
        </Link>

        {/* SUBMENU */}
        <ul
          className={`nxl-submenu ${
            openDropdown === "master" ? "nxl-menu-visible" : "nxl-menu-hidden"
          }`}
        >
          <li
            className={`nxl-item ${
              currentChild === "course-list" ? "active" : ""
            }`}
          >
            <Link to="/master/course-list" className="nxl-link text-capitalize">
              <FiBook className="me-2" />
              Course Master
            </Link>
          </li>
          <li
            className={`nxl-item ${
              currentChild === "semester-list" ? "active" : ""
            }`}
          >
            <Link
              to="/master/semester-list"
              className="nxl-link text-capitalize"
            >
              <FiLayers className="me-2" />
              Semester Master
            </Link>
          </li>
          <li
            className={`nxl-item ${
              currentChild === "subject-list" ? "active" : ""
            }`}
          >
            <Link
              to="/master/subject-list"
              className="nxl-link text-capitalize"
            >
              <FiBookOpen className="me-2" />
              Subject Master
            </Link>
          </li>
          <li
            className={`nxl-item ${
              currentChild === "chapter-list" ? "active" : ""
            }`}
          >
            <Link
              to="/master/chapter-list"
              className="nxl-link text-capitalize"
            >
              <FiFileText className="me-2" />
              Chapter Master
            </Link>
          </li>

          {/* Topic Master */}
          {/* <li
            className={`nxl-item ${
              currentChild === "topic-list" ? "active" : ""
            }`}
          >
            <Link to="/master/topic-list" className="nxl-link text-capitalize">
              <FiList className="me-2" />
              Topic Master
            </Link>
          </li> */}
          <li
            className={`nxl-item ${
              currentChild === "topic-list" ? "active" : ""
            }`}
          >
            <Link to="/master/topic-list" className="nxl-link text-capitalize">
              <FiFile className="me-2" />
              Topic Master
            </Link>
          </li>
        </ul>
      </li>

      {/* MANAGE PACKAGE */}
      <li
        className={`nxl-item nxl-hasmenu ${
          openDropdown === "package" ? "active nxl-trigger" : ""
        }`}
        onClick={() =>
          setOpenDropdown((prev) => (prev === "package" ? null : "package"))
        }
      >
        <Link to="#" className="nxl-link text-capitalize">
          <span className="nxl-micon">
            <FiPackage />
          </span>
          <span className="nxl-mtext ps-1">Manage Package</span>
        </Link>

        <ul
          className={`nxl-submenu ${
            openDropdown === "package" ? "nxl-menu-visible" : "nxl-menu-hidden"
          }`}
        >
          <li
            className={`nxl-item ${
              currentChild === "package-list" ? "active" : ""
            }`}
          >
            <Link
              to="/master/package-list"
              className="nxl-link text-capitalize"
            >
              <FiBook className="me-2" /> Package Master
            </Link>
          </li>
        </ul>
      </li>

      {/* MANAGE STUDENT */}
      <li
        className={`nxl-item nxl-hasmenu ${
          openDropdown === "student" ? "active nxl-trigger" : ""
        }`}
        onClick={() =>
          setOpenDropdown((prev) => (prev === "student" ? null : "student"))
        }
      >
        <Link to="#" className="nxl-link text-capitalize">
          <span className="nxl-micon">
            <FiUsers />
          </span>
          <span className="nxl-mtext ps-1">Manage Student</span>
        </Link>

        <ul
          className={`nxl-submenu ${
            openDropdown === "student" ? "nxl-menu-visible" : "nxl-menu-hidden"
          }`}
        >
          <li
            className={`nxl-item ${
              currentChild === "student-list" ? "active" : ""
            }`}
          >
            <Link
              to="/master/student-list"
              className="nxl-link text-capitalize"
            >
              <FiFileMinus className="me-2" /> Student List
            </Link>
          </li>
          <li
            className={`nxl-item ${
              currentChild === "student-renewal-list" ? "active" : ""
            }`}
          >
            <Link
              to="/master/student-renewal-list"
              className="nxl-link text-capitalize"
            >
              <FiList className="me-2" /> Renewal List
            </Link>
          </li>
        </ul>
      </li>

      {/* LOGOUT */}
      <li
        className="nxl-item"
        onClick={() => {
          localStorage.clear();
          window.location.href = "/";
        }}
      >
        <Link to="#" className="nxl-link text-capitalize">
          <span className="nxl-micon">
            <FiLogOut />
          </span>
          <span className="nxl-mtext ps-1">Logout</span>
        </Link>
      </li>
    </ul>
  );
};

export default Menus;
